import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import EESIcon from './Icons/EESIcon';
import VisaIcon from './Icons/VisaIcon';
import ChevronIconOpen from './Icons/ChevronIconOpen';
import ChevronIconClose from './Icons/ChevronIconClose';
import {
  Container,
  ActionHeader,
  ActionContent,
  ActionHeaderNoExpendable,
  StyledFormH4,
  StyledFlex,
  StyledSpan,
  StyledItem,
  StyledItemList
} from './BorderControlRequirement.styles';

const EES_KEY = 'EES';

export const BorderControlRequirementItem = ({ title, content, expendable, type, dataCy }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [shouldTransition, setShouldTransition] = useState(false);
  const [height, setHeight] = useState(0);
  const contentEl = useRef();

  useEffect(() => {
    if (!contentEl.current || height !== 0) {
      return;
    }

    const computedHeight = window.getComputedStyle(contentEl.current).height;
    setHeight(computedHeight);

    setIsOpen(false);
    setShouldTransition(true);
  }, [contentEl, height]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Container data-cy={dataCy}>
      <StyledFormH4>{title}</StyledFormH4>

      {expendable.length > 0 ? (
        <ActionHeader onClick={toggle} isExpanded={isOpen}>
          <StyledFlex>
            {type === EES_KEY ? <EESIcon /> : <VisaIcon />}
            <StyledSpan>
              {content.map((t, index) => (
                <span key={`content--${index}`}>{t}</span>
              ))}
            </StyledSpan>
            {isOpen ? <ChevronIconClose /> : <ChevronIconOpen />}
          </StyledFlex>
        </ActionHeader>
      ) : (
        <ActionHeaderNoExpendable>
          {type === EES_KEY ? <EESIcon /> : <VisaIcon />}
          <StyledSpan>
            {content.map((t, index) => (
              <span key={`content--${index}`}>{t}</span>
            ))}
          </StyledSpan>
        </ActionHeaderNoExpendable>
      )}

      {expendable.length > 0 && (
        <ActionContent height={height} shouldTransition={shouldTransition} isExpanded={isOpen} ref={contentEl}>
          <StyledItem>
            {expendable.map((t, index) => (
              <StyledItemList key={`expendable--${index}`}>
                {t.map((i, index) => (
                  <span key={`expendable-item--${index}`}>{i}</span>
                ))}
              </StyledItemList>
            ))}
          </StyledItem>
        </ActionContent>
      )}
    </Container>
  );
};

BorderControlRequirementItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.string),
  expendable: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string,
  dataCy: PropTypes.string
};
